/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createResearchAccessRequestResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ResearchAccessRequestResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/access-requests/{accessRequestId}/research
 */
export interface ResearchRequestBuilder extends BaseRequestBuilder<ResearchRequestBuilder> {
    /**
     * Uses AI to research the organization based on the access request information
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ResearchAccessRequestResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ResearchRequestBuilderGetQueryParameters> | undefined) : Promise<ResearchAccessRequestResponse | undefined>;
    /**
     * Uses AI to research the organization based on the access request information
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ResearchRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Uses AI to research the organization based on the access request information
 */
export interface ResearchRequestBuilderGetQueryParameters {
    /**
     * If true, regenerate research even if cached research exists.Defaults to false.
     */
    forceRegenerate?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const ResearchRequestBuilderUriTemplate = "{+baseurl}/api/organizations/access-requests/{accessRequestId}/research?forceRegenerate={forceRegenerate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ResearchRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ResearchRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createResearchAccessRequestResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
